import history from '../history';
import { authService } from './AuthService';

export const validateJsonResponse = response => {
  if (response.ok) {
    return response.json();
  } else if (response.status === 403) {
    authService.resetSession();
    history.push('/login');
    throw new Error('Unauthorized');
  }
  throw response.body;
};

export const validateTextResponse = response => {
  if (response.ok) {
    return response.text();
  } else if (response.status === 403) {
    authService.resetSession();
    throw new Error('Unauthorized');
  }
  throw response.body;
};
